import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { pageRoute } from "../utils/common";

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return !isAuthenticated ? children : <Navigate to={pageRoute.profile} replace />;
};

export default PublicRoute;
